export enum NoteMentionMode {
    BUTTON = 'button',
    INLINE = 'inline',
}
